export default "__VITE_ASSET__U_t_tPxq__"